import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  Renderer2,
} from '@angular/core';

import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HeroBannerComponent } from '../Components/hero-banner/hero-banner.component';
import { GoogleMap, MapMarker, GoogleMapsModule } from '@angular/google-maps';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [CommonModule, RouterLink, HeroBannerComponent, GoogleMapsModule],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent implements OnInit, AfterViewInit {
  constructor(
    private renderer: Renderer2,
    private router: Router,
  ) {}

  @ViewChild('clientContainer') clientContainer!: ElementRef;
  originalLogos = [
    { url: '../../assets/hi-res/logos/limes-logo.png' },
    { url: '../../assets/hi-res/logos/marina-hughes.png' },
    { url: '../../assets/hi-res/logos/elizabeth-matthews.png' },
    { url: '../../assets/hi-res/logos/thorpe-park.png' },
    { url: '../../assets/hi-res/logos/Imperial-Development.png' },
    { url: '../../assets/hi-res/logos/royal-british-construction.png' },
    { url: '../../assets/hi-res/logos/EVOKE-Interiors.png' },
    { url: '../../assets/hi-res/logos/Barar-Homes.png' },
    { url: '../../assets/hi-res/logos/create-spaces.png' },
    { url: '../../assets/hi-res/logos/box-room.png' },
    { url: '../../assets/hi-res/logos/Amy-Parmar-Interiors.png' },
    { url: '../../assets/hi-res/logos/suki-shocker.svg' },
  ];

  logos = [...this.originalLogos, ...this.originalLogos];

  creations = [
    {
      src: '../../assets/hi-res/creations/media-wall.jpeg',
      title: 'media walls',
    },
    {
      src: '../../assets/hi-res/creations/compressed/offices.webp',
      title: 'home offices',
    },
    {
      src: '../../assets/hi-res/creations/compressed/drinks-bars.webp',
      title: 'drinks bars',
    },
    {
      src: '../../assets/hi-res/creations/compressed/wardrobes.webp',
      title: 'wardrobes',
    },
    {
      src: '../../assets/hi-res/creations/commercial-spaces.jpeg',
      title: 'commercial spaces',
    },
  ];

  navOpen = false;
  markerPositions: google.maps.LatLngLiteral[] = [
    { lat: 56.462, lng: -2.9707 }, // Dundee
    { lat: 55.8642, lng: -4.2518 }, // Glasgow
    { lat: 54.4609, lng: -3.0886 }, // Lake District
    { lat: 53.5769, lng: -2.4282 }, // Bolton
    { lat: 53.3811, lng: -1.4701 }, // Sheffield
    { lat: 52.9225, lng: -1.4746 }, // Derby
    { lat: 52.6369, lng: -1.1398 }, // Leicester
    { lat: 52.4862, lng: -1.8904 }, // Birmingham
    { lat: 52.2053, lng: 0.1218 }, // Cambridge
    { lat: 52.0406, lng: -0.7594 }, // Milton Keynes
    { lat: 52.1357, lng: -0.4668 }, // Bedford
    { lat: 51.4543, lng: -0.9781 }, // Reading
    { lat: 51.5074, lng: -0.1278 }, // London
    { lat: 51.3813, lng: -2.359 }, // Bath
    { lat: 51.2802, lng: 1.0789 }, // Canterbury
    { lat: 50.8225, lng: -0.1372 }, // Brighton
    { lat: 50.9097, lng: -1.4044 }, // Southampton
    { lat: 50.7208, lng: -1.9048 }, // Bournemouth
  ];
  markerOptions: google.maps.marker.AdvancedMarkerElementOptions[] = [];

  ngOnInit(): void {
    // this.markerOptions.content.innerHTML = '<div class="custom-marker"></div>';

    this.markerOptions = this.markerPositions.map((position, index) => {
      return {
        title: `Custom Marker ${index + 1}`,
        content: this.createCustomPin(index), // Set unique custom pin for each marker
        // content: pin.element, // Set unique custom pin for each marker
      };
    });
  }

  ngAfterViewInit(): void {}

  createCustomPin(index: number): HTMLElement {
    // Define the custom SVG marker icon
    // Create an SVG element
    const svgElement = `
    <svg width="42" height="42" viewBox="0 0 17 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5,3C11.54,3,14,5.46,14,8.5c0,4.5-5.5,11-5.5,11S3,13,3,8.5C3,5.46,5.46,3,8.5,3z"
            fill="#AF9862"
            stroke="#000"
            stroke-width="1"/>
    </svg>
  `;

    const pinElement = this.renderer.createElement('div');
    this.renderer.addClass(pinElement, 'custom-pin');
    pinElement.innerHTML = svgElement;
    return pinElement;
  }

  // TrackBy function to uniquely identify each marker by its position
  trackByPosition(index: number, position: google.maps.LatLngLiteral): string {
    return `${position.lat}-${position.lng}`;
  }

  options: google.maps.MapOptions = {
    mapId: '446082c3e1e78a8f',
    center: { lat: 54.5, lng: -3.988229 },
    zoom: 5.8,
    disableDefaultUI: true,
    gestureHandling: 'none',
  };

  navigateToCreations(creationTitle: string) {
    const filterMap = {
      'media walls': 'mediaWalls',
      'drinks bars': 'drinksBars',
      'home offices': 'offices',
      wardrobes: 'wardrobes',
      'commercial spaces': 'commercialSpaces',
      other: 'other',
    };

    const filter = filterMap[creationTitle.toLowerCase()];
    this.router.navigate(['/creations'], { queryParams: { filter } });
  }
}
